import { type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const SectionTitle = ({ children }: Props) => (
  <div className="body-semi-large-semibold text-text/primary">{children}</div>
);
